import React from "react";

interface IWorkplaceDetails {
  id: string;
  title: string;
  description: string;
  image: string;
}

const Workplace: React.FC = () => {
  const workplaceDetails: IWorkplaceDetails[] = [
    {
      id: "company-values",
      title: "Company Values",
      description:
        "Trust between teams within and co-operations are the pillars that set at the core of what we do",
      image: "/careers/workplace/company-values.png",
    },
    {
      id: "friendly-atmosphere",
      title: "Friendly atmosphere",
      description:
        "We hold a positive attitude in order to foster respect and decency for our entire team.",
      image: "/careers/workplace/friendly-atmosphere.png",
    },
    {
      id: "work-life-balance",
      title: "Work-life balance",
      description:
        "For us, a healthy personal life is just as important as the time you spend in the office.",
      image: "/careers/workplace/worklife-balance.png",
    },
    {
      id: "grow-everyday",
      title: "Grow Everyday",
      description:
        "We provide the necessary support to ensure your skills never stop growing.",
      image: "/careers/workplace/grow-everyday.png",
    },
  ];

  return (
    <div className="flex flex-col justify-center items-center">
      <div className="flex flex-col w-full max-w-2xl xl:max-w-4xl text-center text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-[4rem] xl:leading-tight">
        <h3>What makes Dream Weavers a</h3>
        <h3>great place to work?</h3>
      </div>
      <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-10 my-10 px-5 justify-center items-center">
        {workplaceDetails.map((workplace, index) => {
          return (
            <div
              className="flex justify-center max-w-96 gap-2 flex-col border p-3"
              key={workplace.id}
            >
              <div>
                <img src={workplace.image} alt="" className="h-auto w-full object-contain" />
              </div>
              <h4 className="font-medium lg:text-xl xl:text-2xl">
                {workplace.title}
              </h4>
              <p className="text-[#53648B] text-xs lg:text-sm">
                {workplace.description}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Workplace;
